module.exports = __webpack_public_path__ + "static/img/katakura_05.6b615aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/katakura_05.jpg
// module id = 88B/
// module chunks = 0